export default "__VITE_PUBLIC_ASSET__f353bc16__"